const parseEnvBoolean = (value: unknown): boolean => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    return ["true", "1", "yes", "on"].includes(value.trim().toLowerCase());
  }

  return false;
};

const getIsProdGuardEnabled = (): boolean => {
  const viteEnv = import.meta.env as Record<string, unknown>;
  return parseEnvBoolean(viteEnv.VITE_IS_PROD ?? viteEnv.IS_PROD);
};

const isBlockedShortcut = (event: KeyboardEvent): boolean => {
  const key = event.key.toLowerCase();
  const isMac = navigator.platform.toLowerCase().includes("mac");
  const primaryModifier = isMac ? event.metaKey : event.ctrlKey;

  if (event.key === "F12") {
    return true;
  }

  // Safari / WebKit (macOS): Web Inspector and related panels use Cmd+Option+…
  // e.g. Cmd+Option+I (Web Inspector), Cmd+Option+C / J (console / sources in many builds).
  if (isMac && event.metaKey && event.altKey) {
    if (["i", "j", "c", "u", "e", "k"].includes(key)) {
      return true;
    }
  }

  if (primaryModifier && event.shiftKey && key === "i") {
    return true;
  }

  if (primaryModifier && event.shiftKey && key === "j") {
    return true;
  }

  if (primaryModifier && event.shiftKey && key === "c") {
    return true;
  }

  if (primaryModifier && event.shiftKey && key === "k") {
    return true;
  }

  if (primaryModifier && key === "u") {
    return true;
  }

  return false;
};

export const setupDevtoolsProtection = (): void => {
  if (!getIsProdGuardEnabled()) {
    return;
  }

  const preventContextMenu = (event: MouseEvent) => {
    event.preventDefault();
  };

  const preventBlockedKeys = (event: KeyboardEvent) => {
    if (isBlockedShortcut(event)) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  document.addEventListener("contextmenu", preventContextMenu);
  window.addEventListener("keydown", preventBlockedKeys, { capture: true });
};
